import readings from './oudekerkIslandRows.json';
import type { BuildContext } from '../../types';
import type { PolygonIndex } from '../../../geo/polygonIndex';
import type { ReservedFootprint } from '../types';
import { obliqueRowLots, type ObliqueRow } from './obliqueRowLots';

export const OUDEKERK_ISLAND_ROWS = readings.rows as unknown as readonly ObliqueRow[];

/** The retained crossings bound the authored block; their centres are not cadastral edges. */
export function oudekerkIslandReservation(
  layout: BuildContext['layout']
): ReservedFootprint | null {
  const find = (id: string) => layout.streets.find((s) => s.id === id)?.centerline;
  const stoof = find('street-stoofsteeg'),
    kennis = find('street-oudekennissteeg');
  if (
    !stoof ||
    !kennis ||
    !find('quay-oudezijds-voorburgwal-3') ||
    !find('quay-oudezijds-achterburgwal')
  )
    return null;
  return {
    id: 'surveyed-oudekerk-island',
    polygon: { outer: [stoof[0], ...kennis, stoof[stoof.length - 1]!], holes: [] },
  };
}

export function planOudeKerkIsland(
  ctx: Pick<BuildContext, 'layout' | 'site'>,
  buildable: PolygonIndex,
  reserved: readonly ReservedFootprint[]
) {
  const block = oudekerkIslandReservation(ctx.layout);
  if (!block) return { lots: [], reserved: [], unresolved: [] };
  const lots = obliqueRowLots(OUDEKERK_ISLAND_ROWS, ctx.layout, buildable, reserved, 40_000);
  const built = new Set(lots.map((l) => l.reconstruction!.id));
  const unresolved = OUDEKERK_ISLAND_ROWS.flatMap((r) =>
    r.houses.flatMap((h) => h.plots?.map((p) => p.id) ?? [h.id]).filter((id) => !built.has(id))
  );
  const footprints = lots.map((l): ReservedFootprint => ({
    id: `surveyed:${l.reconstruction!.id}`,
    polygon: { outer: [...l.corners], holes: [] },
  }));
  // The whole block protects unread rear spaces from procedural rooms and middle buildings.
  return { lots, reserved: [block, ...footprints], unresolved };
}
